import React, { memo } from 'react';
import clsx from 'clsx';

import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';

import Typography from '@smart-tv/components/typography';

import FavoritesEditChannels from '../favorites-edit-channels';
import FavoritesEditSelectedChannels from './favorites-edit-selected-channels';
import FavoritesEditMenu from './favorites-edit-menu';

import testIds from '@smart-tv/e2e/shared/variables';
import styles from '../favorites.module.scss';

interface FavoritesEditProps {
  isHidden?: boolean;
}

export const FavoritesEdit = ({ isHidden = false }: FavoritesEditProps) => {
  const { ref, focusKey } = useFocusable({ focusable: false, isFocusBoundary: true });

  return (
    <FocusContext.Provider value={focusKey}>
      <div
        className={clsx(styles['favorites-edit-layout'], {
          [styles['favorites-edit-layout--hidden']]: isHidden
        })}
        ref={ref}
      >
        <Typography data-testid={testIds.favorites.edit.title} variant="h3">
          Tilføj eller fjern kanaler
        </Typography>
        <div className={styles['favorites-edit-root--content']}>
          <FavoritesEditChannels />
          <FavoritesEditSelectedChannels />
          <FavoritesEditMenu />
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default memo(FavoritesEdit);
